import ReactDOM from 'react-dom/client';
import App from './app';

// Import shared MSAL instance and initialization function
import { ensureMsalInitialized } from './auth/msalClient';

function renderApp() {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(<App />);
}

async function initializeApp() {
  // Detect a popup window returning from the Microsoft auth flow.
  // (has an opener AND the URL carries an auth response in the hash)
  const isPopup = window.opener && window.opener !== window;
  const hasAuthHash = window.location.hash.includes('id_token') ||
                      window.location.hash.includes('access_token') ||
                      window.location.hash.includes('code') ||
                      window.location.hash.includes('state');

  if (isPopup && hasAuthHash) {
    // This is the popup: let MSAL consume the response and DON'T render the app.
    // The popup closes itself once MSAL hands the result back to the opener.
    document.body.innerHTML = '<p style="text-align:center;margin-top:50px;">Completing sign-in...</p>';
    try {
      await ensureMsalInitialized();
    } catch (e) {
      console.debug('MSAL init in popup failed', e);
    }
    return;
  }

  // Main window: render the app IMMEDIATELY. Never block first paint on MSAL —
  // initializing it (and especially probing for a silent SSO session) can take
  // several seconds, which showed up as a long white screen on the login page.
  renderApp();

  // Initialize MSAL in the background so the "Continue with Microsoft" popup
  // flow is ready when the user clicks it. Failure here is non-fatal.
  ensureMsalInitialized().catch((e) => console.debug('MSAL background init failed', e));
}

initializeApp();
